import Vue from 'vue'

import familytree from './assets/components/familytree.vue'
import sidepanel from './assets/components/sidepanel.vue'
Vue.component('familytree', familytree)
Vue.component('sidepanel', sidepanel)

import Transitions from 'vue2-transitions'
Vue.use(Transitions)

const audioplay = require('audio-play');
const audioload = require('audio-loader');
const audio = {click:     'static/audio/click_positive_01.mp3',
               click_neg: 'static/audio/click_negative_01.mp3',
               create:    'static/audio/create_descendant_01.mp3',
               swipe:     'static/audio/grab_timeline_01.mp3'}


require('./assets/stylesheets/app.scss')

var $ = require('jquery')

if (!window.navigator.oscpu) window.navigator.oscpu = window.navigator.platform

$('body').addClass(window.navigator.oscpu.toLowerCase().includes("win") ? "os-windows" : "os-notwindows")

var ua = window.navigator.userAgent.toLowerCase();
$('body').addClass(ua.includes("windows nt 10") ? "win10" : "")
$('body').addClass(ua.includes("chrome") ? "br-chrome" : "")
$('body').addClass(ua.includes("firefox") ? "br-firefox" : "")
$('body').addClass(ua.includes("edge") || ua.includes("trident") ? "br-ie" : "")
$('body').addClass(ua.includes("windows nt 6.1") ? "win7" : "")

// Prevent swipe navigation
$(document).on("mousewheel",function(event,delta){ 
  if (event.originalEvent.wheelDeltaX !== 0) {
    event.preventDefault();
  } 
});
$(document).on("contextmenu",function(e){
  return false;
});

import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
  id: 'UA-28388718-3'
})

////////////////////////
// Utility functions
////////////////////////

// Viewport scaling

var scaleFactor;

$(window).resize(function () {
  var width = $(window).width();
  if (width < 768) {
    var width = 768;
  }
  scaleFactor = width / 1920;
  $('body').css({transform: "scale(" + scaleFactor + ")"});
});

$(function () {
  $(window).resize();
});

// Logging

var LOGGING = 0
var log = LOGGING == 1 ? console.log : function(){return}

// Slugify

var slugify = function(text) {
  return text
    .toLowerCase()
    .replace(/[^\w ]+/g,'')
    .replace(/ +/g,'-')
}

// Array shuffle, php style! >:(

function array_shuffle(a,b,c,d){
	c=a.length;while(c)b=Math.random()*c--|0,d=a[c],a[c]=a[b],a[b]=d
}

////////////////////////
// App
////////////////////////

var content = { "intro": {"title": "Inheritance Lottery",
					  "text": "The DNA you inherit – and the DNA you don’t – is partly down to chance. Play the Inheritance Lottery to see how in each generation some DNA is passed on, and some is lost."},
				"select": {"title": "Select a DNA pool profile",
						   "text": "The DNA pool is used to create DNA for the great grandparents in the Inheritance Lottery. The profiles produce different ancestry patterns in the family tree.",
						   "options": [{"image": "mixed-less.svg",
						   				"title": "Less mixed",
						   				"text": "Lorem ipsum dolor sit amet consectutir adipiscing elit."},
									   {"image": "mixed-partly.svg",
									    "title": "Partly mixed",
									    "text": "Lorem ipsum dolor sit amet consectutir adipiscing elit."},
									   {"image": "mixed-more.svg",
									    "title": "More mixed",
									    "text": "Lorem ipsum dolor sit amet consectutir adipiscing elit."}]},
				"familytree": {"text":"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris efficitur porttitor massa, sit amet fermentum lorem sodales et.",
							   "buttons":["Generate new DNA","End Lottery"]},
				"buttons": {
					"intro": "Start"
				}}



var navMatrix = { 0 : { 0 : { "zoomIn"  : 0 }},
				  1 : { 0 : { "zoomIn"  : 0 , "zoomOut" : 0 },
				  		1 : { "zoomIn"  : 3 , "zoomOut" : 0 }},
				  2 : { 0 : { "zoomOut" : 0 }, 1 : { "zoomOut" : 0 }, 2 : { "zoomOut" : 1 }, 3 : { "zoomOut" : 1 }}}

var app = new Vue({
	el: '#app',
	data: {
		DISPLAYMODE: { intro: 0,
					   interactive: 1},
		mode: 0,
		timeout: 120,
		doTutorial: 1,
		initGeneClasses: 3,
		geneClasses: 3,
		content: content,
		tutorial: { buttons : { runagain : { text: "Run lottery again" },
							 startover : { text: "Run lottery again" } },
				 steps   : [ { title : "Building blocks",
							   content: `The human genome is very long, with thousands of chemical pairs. To keep things simple, we’ll give each person just four pairs – shown as coloured balls.
										The colours represent different types of ancestry. Let’s say pink circles are Scandinavia, red are China, yellow are Germany and so on.
										Each ball has its own number, to help you trace it down the family tree.
										Tap <span class='tutorial-icon'>+</span> to create a child.` },
							 { title : "Make a baby",
							   content: `In each row, the child inherits one DNA ‘ball’ from the mother and one from the father.
							   			 Faded colours show those that are not passed on.
							   			 Has the child already lost traces of an ancestry colour?
										 Let’s see how this works over more generations…` },
							 { title : "Build a family tree",
							   content: `We’ve given all eight great-grandparents DNA ancestry.
										 Tap the <span class='tutorial-icon'>+</span> signs to create each child and watch how ancestry colours and individual balls pass on or become lost.` },
							 { title : "A unique mix",
							   content: `The great grandchild’s DNA is the result of chance inheritance down the family tree.
							   			 Have they lost any ancestral colours? Did they inherit a numbered ball from every great grandparent?
							   			 This is very simplified: the human genome contains thousands of chemical pairs, not just four.
										 In reality we do not inherit DNA from every one of our ancestors, and most of your ancestors of more than 400 years ago passed on very little or none of their DNA down to you.` },]},
		tutorialStep: 0,
		minZoom: 0,
		maxZoom: 2,
		zoomLevel: 2,
		position: 0,
		navMatrix: navMatrix,
		ancestors: 3,
		names: [['You'],
				 ['Mother','Father'],
				 ['Grandmother','Grandfather'],
				 ['Great Grandmother','Great Grandfather']],
		allNations: ["scotland & ireland", "england & wales", 'france', "iberia", "scandinavia", "china", "north africa", "germany", 'northeast europe' ,'india'],
		numNationalities: 8,
		genes: [],
		you: null,
		timer: 0,
		sessionTimer: 0,
		created: 0,
		inheritancePermutations: [[[0,1],[0,1],[1,0],[1,0]],
								  [[0,1],[1,0],[0,1],[1,0]],
								  [[0,1],[1,0],[1,0],[0,1]],
								  [[1,0],[0,1],[1,0],[0,1]],
							      [[1,0],[1,0],[0,1],[0,1]],
								  [[1,0],[0,1],[0,1],[1,0]]]

	},
	mounted: function() {
		this.reset()
		this.resetTimer()
		setTimeout(function(){
	      $('body').removeClass('loading')
	      setTimeout(function(){
	        $('.loader').remove()
	      }, 1000);
	    }, 2000);
	},
	computed: {
		navTransform: function() {
			var scaleFactor = 1 / Math.pow(2, this.zoomLevel)
			var dX =  (this.position * scaleFactor * -100) + '%'
			var dY
			switch (this.zoomLevel) {
				case this.minZoom:
					dY = '20%'
					break
				case this.maxZoom:
					dY = '0%'
					break
				default:
					dY = '-2%'

			}
			var transform = `scale(${this.zoom}) translate(${dX}, ${dY})`
			return transform
		},
		zoom: function () {

			// 3 => 1 = 1 / 2^(0)
			// 2 => 0.5 = 1 / 2^(1)
			// 1 => 0.25 = 1 / 2^(2)
			// z = 1 / 2^(maxZoom - zoomLevel)

			return 1 / Math.pow(2, this.maxZoom - this.zoomLevel)
		},
		yourChromosomes: function() {
			try {
				var $chromosomes = $('<ul/>', {class: 'chromosomes'});
				for (var _c in this.you.genome) {
					var chromosome = this.you.genome[_c]
					var $chromosome = $('<li/>', {class: 'chromosome'});
					var $genes = $('<ul/>', {class: 'genes'});
					for (var _gene in chromosome) {
						var genedata = chromosome[_gene]
						var $gene = $('<li/>', {class: 'gene gene--'+slugify(genedata.origin)})
						$gene.append($(`<span>${genedata.gene}</span>`))
						$genes.append($gene)
					}
					$chromosome.append($genes)
					$chromosomes.append($chromosome)
				}
				return $chromosomes[0].outerHTML
			} catch (e) {
				return ""
			}
		}
	},
	methods: {
		slugify: slugify,
		incrementTimer: function() {
	      var vm = this;
	      vm.timer += 1;
	      vm.sessionTimer += 1;
	      clearTimeout(vm.timerIncrementer);
	      vm.timerIncrementer = setTimeout(vm.incrementTimer, 1000);
	    },
	    resetTimer: function() {
	      this.timer = 0;
	      this.incrementTimer();
	    },
	    EV: function(action, label, value) {
	      if (!action) action = '';
	      if (!label) label = '';
	      if (!value) value = '';
	      this.$ga.event('inheritance_lottery', action, label)
	      this.resetTimer();
	    },
		p: function(s) {
			var output = "<p>" + s.replace(/$\n^\s*/gm, "</p><p>") + "</p>"
			return output
		},
		zoomIn: function() {
			var nav = this.navMatrix[this.zoomLevel]
			var nextPosition = this.navMatrix[this.zoomLevel][this.position]
			if (typeof(nextPosition) != 'undefined' && typeof(nextPosition['zoomIn']) != 'undefined') {
				this.position = nextPosition['zoomIn'];
				this.zoomLevel += 1;
			}
		},
		zoomOut: function() {
			var nav = this.navMatrix[this.zoomLevel]
			var nextPosition = this.navMatrix[this.zoomLevel][this.position]
			if (typeof(nextPosition) != 'undefined' && typeof(nextPosition['zoomOut']) != 'undefined') {
				this.position = nextPosition['zoomOut'];
				this.zoomLevel -= 1;
			}
		},
		goRight: function() {
			if (this.zoomLevel == 1 && this.position < 1) this.position += 1
			if (this.zoomLevel == 2 && this.position < 3) this.position += 1
		},
		goLeft: function() {
			if (this.position > 0) this.position -= 1
		},
		getNavOpacity: function(direction) {
			if (direction == 'left') {
				if (this.zoomLevel > 0 && this.position > 0) return '1'
			} else if (direction == 'right') {
				if (this.zoomLevel == 1 && this.position < 1) return '1'
				if (this.zoomLevel == 2 && this.position < 3) return '1'
			}
			return '0'
		},
		tutorialNext: function() {
			if ( this.tutorialStep < this.tutorial.steps.length-2) {
				this.zoomOut()
				this.tutorialStep += 1
			} else if (this.tutorialStep < this.tutorial.steps.length-1 && this.you.born) {
				this.tutorialStep += 1
			} else {
				this.zoomOut()
			}
		},
		initGeneNumbers: function() {
			var geneNumbers = Array.apply(null, {length: 99}).map(Number.call, Number)
			geneNumbers.shift()
			array_shuffle(geneNumbers)
			this.geneNumbers = geneNumbers
		},
		initNationalities: function() {

			this.nationalities = JSON.parse(JSON.stringify(this.allNations));
			array_shuffle(this.nationalities)

			var numNationalities = this.numNationalities
			this.nationalities = this.nationalities.slice(0,this.numNationalities) // Limit number to choose from
			this.primaryOrigin = this.nationalities.pop()
			this.secondaryOrigin = this.nationalities.pop()
			this.primarySecondaryMix = [ 0.6 , 0.3 ] // must sum to < 1!

		},
		initGenes: function() {
			for (var i = this.geneNumbers.length - 1; i >= 0; i--) {
				var r = Math.random();
				// Primary, secondary or misc?
				var o;
				if (r < this.primarySecondaryMix[0]) {
					o = this.primaryOrigin
				} else if (r < this.primarySecondaryMix[1]) {
					o = this.secondaryOrigin
				} else {
					o = this.nationalities[Math.floor(Math.random() * this.nationalities.length)];
				}
				this.genes.push({geneNumber: this.geneNumbers[i].toString(), origin: o});
			}
		},
		populateParents: function(branch, generation) {

			// // Recursive function to populate a persons ancestry

			if (arguments.length == 0) {
				branch = 0
				generation = 0
			}

			var spacer = ' '.repeat(4*generation)

			var person = {name: this.names[generation][branch], parents: [], genome: [], born: false}

			var inheritancePermutation = this.inheritancePermutations[Math.floor(Math.random() * this.inheritancePermutations.length)];

			for (var p in [0,1]) { // Each person has two parents, so...

				log(spacer, "Currently processing genome for:", person.name, "Parent " + p)

				if (generation == this.ancestors) { // This parent is at the root of the tree, so we populate a full genome from scratch

					var chromosome = JSON.parse(JSON.stringify(this.genes.slice(0,4))) // We take an 4-element chunk off the front of the global genes array...
					this.genes = this.genes.slice(4); // Then update the global genes array to remove those 4 elements

					// Build a more detailed 'gene' object using each of the elements. 
					chromosome = chromosome.reduce(function(result, item, index) {
						result.push({gene: item.geneNumber, origin: item.origin, inheritedByChild: false})
						return result
					}, []); // note the empty array we pass as the initial argument to the reduce function

					person.born = true

				} else { // We haven't reached the oldest ancestors yet

					log(spacer, "Recursion {")
					person.parents.push( this.populateParents(p, generation + 1) ); // Go crazy, recursion style
					log(spacer, "}")
					
					var parent = person.parents[p]; // Get the newly populated parent object

					var chromosome = []
					for (var i in [0,1,2,3]) {
						var inherited = [parent.genome[0][i], parent.genome[1][i]].filter(g => g.inheritedByChild)[0]
						chromosome.push({gene: inherited.gene, origin: inherited.origin, inheritedByChild: false});
					}

				}

				if (generation != 0) {

					for (var perm in inheritancePermutation) {
						chromosome[perm].inheritedByChild = inheritancePermutation[perm][p]==1 ? true : false;
					}

				}
				person.genome.push(chromosome); // Finally, save each chromosome to the current person's genome
			}

			return person

		},
		reset: function(timeout) {

			var vm = this;

			vm.play('click_neg');

			if (!!timeout) this.mode = 0

			$('.familytree').addClass('unborn');

			this.tutorialStep = 0
			this.zoomLevel = this.maxZoom
			this.position = 0
			this.initGeneNumbers();
			this.initNationalities();
			this.initGenes();

			vm.$ga.event('inheritance_lottery', 'session_end', vm.sessionTimer)
			this.sessionTimer = 0;
			this.created = 0;

			// Reset the balls

			$('.ball-lines').each(function(i, e) {
				var newone = e.cloneNode(true);
				e.parentNode.replaceChild(newone, e);
			})

			setTimeout(function() {
				vm.you = vm.populateParents();
				$('.familytree--0').removeClass('unborn');
			}, !!timeout ? 500 : 1200)
		},
		play: function(sound) {

	      switch (sound) {
	        case 'click':
	          audioload(audio.click).then(audioplay);
	          break
	        case 'click_neg':
	          audioload(audio.click_neg).then(audioplay);
	          break
	        case 'create':
	          audioload(audio.create).then(audioplay);
	          break
	      }

	    },
	},
	watch: {
		timer: function() {
			var vm = this;
			if (vm.timer > vm.timeout) {
				vm.reset(true);
				vm.resetTimer();
			}
	    },
	    tutorialStep: function() {
	    	if (this.tutorialStep == this.tutorial.steps.length - 1) {
	    		$('.branding__people').addClass('opacity0');
	    	} else {
	    		$('.branding__people').removeClass('opacity0');
	    	}
	    }
	}
})







// WEBPACK FOOTER //
// ./src/main.js